import { createSelector } from '@reduxjs/toolkit';

const anonymousScoringState = (state) => {
    return state.persistedReducer.anonymousScoringReducer
}

export const getSessionIdSelector = () => createSelector(anonymousScoringState,(state) =>{
    return state?.sessionId || null
})

export const getSessionActiveSelector = () => createSelector(anonymousScoringState,(state) =>{
    return state?.isSessionActive || false
})

export const getVotesSelector = () => createSelector(anonymousScoringState,(state) =>{
    return state?.votes || []
})

export const getStoredVotesSelector = () => createSelector(anonymousScoringState,(state) =>{
    return state?.storedVotes || {}
})

export const getProtectiveMeasuresSelector = () => createSelector(anonymousScoringState,(state) =>{
    return state?.protectiveMeasures || {}
})

export const getErrorSelector = () => createSelector(anonymousScoringState,(state) =>{ 
    return state?.error || null
})

export const getAnonymousScoringLoadingState = () => createSelector(anonymousScoringState,(state) =>{
    return state?.isLoading || false
})